var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00005 0C4.02951 0 0 4.04636 0 9.03768C0 13.5143 3.2447 17.2217 7.49902 17.9396V10.9232H5.32795V8.39825H7.49902V6.53647C7.49902 4.37626 8.81292 3.19907 10.7322 3.19907C11.6515 3.19907 12.4414 3.26786 12.6708 3.29815V5.55614L11.3396 5.55679C10.296 5.55679 10.0948 6.05466 10.0948 6.78551V8.39696H12.5849L12.2601 10.9219H10.0948V18C14.5478 17.4558 18 13.6539 18 9.03509C18 4.04636 13.9705 0 9.00005 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a6b2f5641e1d70c479f338c73be0ed31.svg";
export { ForwardRef as ReactComponent };